<shared-assets-image [assetFile]="assetFile" [size]="size" (loaded)="loaded.emit(true)" (errored)="errored.emit(true)">
  <shared-asset-image-content>
    <div class="left" (click)="openLink()" *ngIf="details">
      <div class="top">
        <framework-work-status-chip [workStatus]="$any(project)?.status" [darkMode]="true"></framework-work-status-chip>

        <p class="subtitle">
          {{ project.productType ? project.productType.name + ' •' : null }} {{ project.projectEndDate | date : 'MMM dd,
          YYYY' }}
        </p>
      </div>
      <p class="title">{{ $any(project)?.feedDetails.organizationName || $any(project)?.feedDetails.feedName}}</p>
      <p class="title">{{ project?.name }}</p>
    </div>

    <div class="click" (click)="openLink()"></div>

    <app-clusted-profile-images *ngIf="showMembers === true && project?.members" [userList]="project.members">
    </app-clusted-profile-images>
  </shared-asset-image-content>
</shared-assets-image>
